import React, { useEffect, useState } from 'react'
import './Simulation.scss'
import Feedback from './Feedback'
import Modal from '../common/Modal/Modal'
import Button from '../../../partials/UI/Button'
import Media from '../../../partials/Media'
import MissionResults from './MissionResults'

const Simulation = (props) => {

    const { data, onComplete } = props
    const {bandResponses, orbitResponses, linkResponses } = data
    /** States */
    const [simulationData, setSimulationData] = useState();
    const [missionResult, setMissionResult] = useState();
    const [showFeedback, setShowFeedback] = useState(false);
    
    useEffect(()=> {
        
        setSimulationData(data)
        
    },[])

    const handleComplete = () => {
        // onComplete();
    }

    const handleRunSimulation = () => {

        if(!simulationData){
            setMissionResult({
                state: 'incomplete',
                text:'This could work!'
            })
        }
        else{

            setMissionResult({
                state: 'success',
                text:'This could work!'
            })

        }
        // setShowFeedback(true)
    }

    const handleClose = () => {
        setShowFeedback(false)

    }
    return (
        <>
            { showFeedback && 
                <Modal 
                    size="small" 
                    show={true} 
                    onClose={ handleClose }
                    header={missionResult.text}>
                            
                    <Feedback />
                    <Button text="Continue" className="small centered primary" onClickHandle={handleComplete}  />
                        
                </Modal>
            }
            <div className='payload-simulation'  >
                
                <div className='columns'>
                    
                    {missionResult && <MissionResults result={missionResult} /> }

                    {bandResponses &&
                        <>
                            {bandResponses.questions.map((question, index) => (
                                <div key={index} className="response-container">
                                    <strong>{question.text}:</strong>
                                    <div>{ question.answers[0].title }</div>
                                </div>

                            ))}
                        </>
                    }

                    {orbitResponses &&
                        <>
                            {orbitResponses.map((question, index) => (
                                <div key={index} className="response-container">
                                    <strong key={index}>{question.label}:</strong>
                                    {question.answers.map((answer, index) => (
                                        <div key={`asnwr_${index}`}>{ answer.option }</div>
                                    ))}
                                </div>

                            ))}
                        </>
                    }

                    {linkResponses &&
                        <>
                            {linkResponses.map((response, index) => (
                                <div key={index}>{ response.name }: {response.value}</div>
                            ))}
                        </>
                    }
                </div>
                <div className='columns'>
                    <Media 
                        type={'image'}
                        src={'https://widenetworks.net/wp-content/uploads/2016/11/testing.png'}
                    />
                </div>
                <div className='columns'>
                    <Button 
                        text="Run Simulation" 
                        onClickHandle={handleRunSimulation} 
                        className="sim-btn small primary"
                    />
                </div>
            </div>
        </>
    )

}

export default Simulation;